import { ModalBody, Container, ModalFooter, ModalHeader } from './styles'
import { MdClose } from 'react-icons/md'
import { GreenButton } from '../../../../../components/Buttons/GreenButton'
import { iModalPadrao } from '../../../../../interfaces'
import { useEffect, useState } from 'react'
import { useFormulario } from '../../../../../contexts/FormularioContext'
import Modal from 'react-modal'
import { InputFormControl } from '../../../../../components/InputFormControl'

interface IModal extends iModalPadrao {
  competenciaId: string
  duplicar: boolean
  questaoId?: string
}

export const ModalQuestao: React.FC<IModal> = ({ OnCloseModal, isOpen, competenciaId, questaoId, duplicar }) => {
  if (!isOpen) {
    return null
  }
  const { CriarQuestao, AtualizarQuestao, ctxCompetencias } = useFormulario()
  const [Texto, setTexto] = useState('')
  const [ITipo, setITipo] = useState(0)

  function GetQuestao(): void {
    const selecao = ctxCompetencias.find(e => e.id === competenciaId)
    if (selecao !== undefined) {
      const questao = selecao.questoes.find(r => r.id === questaoId)
      if (questao !== undefined) {
        setITipo(questao.tipo)
        setTexto(questao.enunciado)
      }
    }
  }

  function isDiscursiva(): boolean {
    const selecao = ctxCompetencias.find(e => e.id === competenciaId)
    if (selecao !== undefined) {
      return selecao.discursiva
    }
    return false
  }

  useEffect(() => {
    if (questaoId !== undefined) { GetQuestao() }
    setITipo(isDiscursiva() ? 1 : 0)
  }, [])

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={OnCloseModal}
      overlayClassName='react-modal-overlay'
      className='react-modal-content-default'
    >
      <Container>
        <ModalHeader>
          <h2>{questaoId === undefined ? 'Criar' : 'Editar'} Questão</h2>
          <MdClose
            onClick={() => OnCloseModal()}
            cursor={'pointer'}
            color={'var(--a2)'}
            size={24}
          />
        </ModalHeader>

        <ModalBody>
          <InputFormControl
            placeholder='Digite uma questão aqui'
            onChange={(e) => setTexto(e.target.value)}
            value={Texto}
          />
        </ModalBody>

        <ModalFooter>
          {
            (questaoId === undefined && !duplicar) && (
              <GreenButton
                Size='md'
                isNav={false}
                OnClick={() => { CriarQuestao(competenciaId, Texto, ITipo); OnCloseModal() }}
              >Criar questão</GreenButton>
            )
          }

          {
            (questaoId !== undefined && !duplicar) && (
              <GreenButton
                Size='md'
                isNav={false}
                OnClick={() => { AtualizarQuestao(competenciaId, questaoId, Texto); OnCloseModal() }}
              >Editar questão</GreenButton>
            )
          }

          {
            (questaoId !== undefined && duplicar) && (
              <GreenButton
                Size='md'
                isNav={false}
                OnClick={() => { CriarQuestao(competenciaId, Texto, ITipo); OnCloseModal() }}
              >Duplicar questão</GreenButton>
            )
          }
        </ModalFooter>
      </Container>
    </Modal>
  )
}
